// extracted by mini-css-extract-plugin
export var container = "_51-0";
export var infoButton = "_51-1";
export var label = "_51-3";
export var labelExpanded = "_51-4";
export var price = "_51-5";
export var priceExpanded = "_51-6";
export var title = "_51-2";